import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=1b6616a0&"
import script from "./ClientSelect.vue?vue&type=script&lang=js&"
export * from "./ClientSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports